var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.9966,
    height: 36,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.9966,
    height: 35,
    rx: 7.5,
    stroke: "#040517",
    strokeOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_3933)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3877 24.269H27.3464V11.708H20.3877V24.269Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8295 17.9885C20.8295 15.4402 22.0173 13.1705 23.867 11.708C22.5141 10.6382 20.8074 10 18.9521 10C14.5602 10 11 13.5766 11 17.9885C11 22.4003 14.5602 25.9769 18.9521 25.9769C20.8074 25.9769 22.5141 25.3388 23.867 24.269C22.0173 22.8062 20.8295 20.5368 20.8295 17.9885Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4856 22.9386V22.6286H36.405L36.3124 22.8419L36.2196 22.6286H36.139V22.9386H36.1958V22.7047L36.2828 22.9064H36.3418L36.4288 22.7043V22.9386H36.4856ZM35.9751 22.9386V22.6814H36.0785V22.6291H35.8156V22.6814H35.9188V22.9386H35.9751ZM36.7339 17.9884C36.7339 22.4003 33.1735 25.9769 28.7818 25.9769C26.9266 25.9769 25.2196 25.3387 23.8669 24.2689C25.7166 22.8064 26.9045 20.5367 26.9045 17.9884C26.9045 15.4403 25.7166 13.1707 23.8669 11.7079C25.2196 10.6381 26.9266 9.99994 28.7818 9.99994C33.1735 9.99994 36.7339 13.5766 36.7339 17.9884Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_3933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16,
    fill: "white",
    transform: "translate(11 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.ba88b35bffc0bcc825fe311308681836.svg";
export { ForwardRef as ReactComponent };